import { render, staticRenderFns } from "./CheckDetail.vue?vue&type=template&id=71cad3d6"
import script from "./CheckDetail.vue?vue&type=script&lang=js"
export * from "./CheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports